module.exports = __webpack_public_path__ + "glampinghub-logo.png?0235decce45b5a36003f7ec7a6e4d7f4";